import { color, duration, } from "@mittwald/flow-styles/dist/tokens/ts/variables";
import styled from "styled-components";
import Box from "../../Box/Box";
export const OptionContainer = styled(Box) `
  cursor: pointer;
  user-select: none;
  transition: background-color ${duration.animation.fast}ms ease;

  &:focus {
    outline: none;
    background-color: ${color.background.selectableBox.hovered};
  }

  &:hover,
  &.hover,
  &.selected {
    background-color: ${color.background.selectableBox.selected};
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiT3B0aW9uQ29udGFpbmVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvU2VsZWN0L3N0eWxlZC9PcHRpb25Db250YWluZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUNMLEtBQUssRUFDTCxRQUFRLEdBQ1QsTUFBTSxnREFBZ0QsQ0FBQztBQUN4RCxPQUFPLE1BQU0sTUFBTSxtQkFBbUIsQ0FBQztBQUN2QyxPQUFPLEdBQUcsTUFBTSxlQUFlLENBQUM7QUFFaEMsTUFBTSxDQUFDLE1BQU0sZUFBZSxHQUFHLE1BQU0sQ0FBQyxHQUFHLENBQUMsQ0FBQTs7O2lDQUdULFFBQVEsQ0FBQyxTQUFTLENBQUMsSUFBSTs7Ozt3QkFJaEMsS0FBSyxDQUFDLFVBQVUsQ0FBQyxhQUFhLENBQUMsT0FBTzs7Ozs7O3dCQU10QyxLQUFLLENBQUMsVUFBVSxDQUFDLGFBQWEsQ0FBQyxRQUFROztDQUU5RCxDQUFDIn0=